import BaseModuleMixin from '../../../mixins/BaseModuleMixin'
// import BaseGestaoMixin from '../../../mixins/BaseGestaoMixin'

export default {
    mixins: [
        BaseModuleMixin,
        // BaseGestaoMixin
    ],
    data(){
        return {

        }
    },
    computed: {
        moduleInternalCode() {
            return this.moduleId;
        },
    },
}
